'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toggle = require('stampy/lib/component/Toggle');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-goose/lib/Toggle.js
// module id = 119
// module chunks = 35783957827783 114276838955818 162898551421021